// @TODO: this doesn't work on dev, but prod is fine.  think it's a layout/measurement issue
/*
 * Ryan O'Dowd
 * 2024-09-28
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  ProgressBar as PaperProgressBar,
} from 'react-native-paper';
import React from 'react';
import getStyles from './styles';
import hooks from '@hooks';

const LinearProgress = (props: React.ComponentProps<typeof PaperProgressBar>) => {
  const styles = hooks.useStyles(getStyles);

  return (
    <PaperProgressBar
      {...props}
      color={props.color || (props.progress >= 1 ? styles.colors.accent : styles.colors.primaryLight)}
      style={[styles.progressBar(props.progress >= 1), props.style]}
      progress={Math.min(props.progress, 1)}
    />
  );
};

export default LinearProgress;
